import {
  createRouter,
  createWebHashHistory
} from "vue-router";
const routes = [
  {
    path: "/",
    redirect: { name: 'sendInquiry' }
  },
  {
    path: "/chat",
    name: "chat",
    component: () => import('@/slack/chat'),
  },
  {
    path: "/chat1",
    name: "chat1",
    component: () => import('@/slack/chatCustomer'),
  },
  {
    path: "/chatWeb",
    name: "chatWeb",
    component: () => import('@/slack/chat1'),
  },
  {
    path: "/chat2",
    name: "chat2",
    component: () => import('@/slack/chat2'),
  },
  {
    path: "/chatCustomer",
    name: "chatCustomer",
    component: () => import('@/slack/chatCustomer'),
  },
  {
    path: "/chatCustomer1",
    name: "chatCustomer1",
    component: () => import('@/slack/chatCustomer1'),
  },
  {
    path: "/sendInquiry",
    name: "sendInquiry",
    component: () => import('@/slack/sendInquiry'),
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
const version = "1"
router.afterEach(() => {
  const localVersion = localStorage.getItem('version')
  if (localVersion) {
    if (localVersion != version) {
      localStorage.setItem('version', version)
      window.location.reload()
    }
  } else {
    localStorage.setItem('version', version)
    window.location.reload()
  }
})
export default router;